import { useMemo } from 'react';

import {
  ViewportBreakpoint,
  viewportBreakpointArray,
} from './getViewportBreakpoint';
import { useViewportBreakpoint } from './useViewportBreakpoint';

export function useViewportBreakpointValue<T>(
  values: Partial<Record<ViewportBreakpoint, T>>
) {
  const viewportBreakpoint = useViewportBreakpoint();

  return useMemo(() => {
    const valuesArray = [values.xs, values.sm, values.md, values.lg];
    const viewportBreakpointIndex =
      viewportBreakpointArray.indexOf(viewportBreakpoint);

    // eslint-disable-next-line for-direction
    for (let i = viewportBreakpointIndex; i <= 0; i--) {
      const value = valuesArray[i];
      if (value !== undefined) return value;
    }

    return valuesArray.filter(Boolean)[0];
  }, [values.xs, values.sm, values.md, values.lg, viewportBreakpoint]);
}
